module.exports = __webpack_public_path__ + "media/images/coupon/coupon_illustration_web-fff7ab21f1885acdb94fc54aaa1e1718.png";